import { render } from "./BaseNotify.vue?vue&type=template&id=1fbfef65&scoped=true"
import script from "./BaseNotify.vue?vue&type=script&lang=js"
export * from "./BaseNotify.vue?vue&type=script&lang=js"

import "./BaseNotify.vue?vue&type=style&index=0&id=1fbfef65&lang=css&scoped=true"

import exportComponent from "E:\\Projects\\webDesign\\trello-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fbfef65"]])

export default __exports__